export default () => ({
	sticky: true,
	show_menu: false,
	show_search: false,
	show_account: false,
	show_cart: false,
	show_localization: false,
	show_store_locator: false,
	header_container: document.querySelector('.store-header'),

	openMenu() {
		this.show_menu = true;
		this.header_container.style.zIndex = '50';
	},

	closeMenu() {
		this.show_menu = false;
		this.header_container.style.zIndex = '10';
	},

	openLogin() {
		this.show_account = true;
		this.header_container.style.zIndex = '50';
	},

	closeLogin() {
		this.show_account = false;
		this.header_container.style.zIndex = '10';
		this.$dispatch('account-closed', { closed: true });
	},

	openSearch() {
		this.show_search = true;
		this.header_container.style.zIndex = '50';
	},

	closeSearch() {
		this.show_search = false;
		this.header_container.style.zIndex = '10';
		this.$dispatch('search-closed', { closed: true });
	},

	toggleLocalization() {
		this.show_localization = !this.show_localization;
	},

	closeLocalization() {
		this.show_localization = false;
	},

	openStoreLocator() {
		this.show_store_locator = true;
		this.show_menu = false;
		this.header_container.style.zIndex = '50';
	},

	closeStoreLocator() {
		this.show_store_locator = false;
		this.header_container.style.zIndex = '10';
		this.$dispatch('store-locator-closed', { closed: true });
	},

	enableSticky() {
		if (!this.sticky) return;
		const annauncement_bar = document.getElementById('announcement-bar');
		if (annauncement_bar) {
			let top_offset;
			const countdown = document.querySelector('.count-down-container');
			if (countdown) {
				top_offset = annauncement_bar.offsetHeight + countdown.parentNode.clientHeight;
			} else {
				top_offset = annauncement_bar.offsetHeight;
			}

			if (window.scrollY > top_offset + 10) {
				this.$refs.header.classList.add('header--sticky-start');

				if (this.windowWidth > 767) {
					this.$refs.menu.style.top = 0 + 'px';
					this.$refs.search.style.top = 0 + 'px';
					if (this.$refs.account) {
						this.$refs.account.style.top = 0 + 'px';
					}
					this.$refs.storeLocator.style.top = 0 + 'px';
				}
			} else {
				if (this.$refs.header.classList.contains('header--sticky-start')) {
					this.$refs.header.classList.remove('header--sticky-start');

					if (this.windowWidth > 767) {
						this.$refs.menu.style.top = top_offset + 'px';
						this.$refs.search.style.top = top_offset + 'px';
						if (this.$refs.account) {
							this.$refs.account.style.top = top_offset + 'px';
						}
						this.$refs.storeLocator.style.top = top_offset + 'px';
					}
				}
			}
		}
	},

	checkReverseLogo() {
		const main = document.getElementById('main-content');
		if (
			!main.children[0].classList.contains('banner') &&
			!window.location.href.includes('rewards')
		) {
			this.$refs.header.classList.add('header--black');
		}
	},

	init() {
		this.checkReverseLogo();
		this.enableSticky();
		document.addEventListener('open:storeLocator', () => {
			this.show_store_locator = true;
		});
	},
});
